import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import { getPurchaseOrders } from '../../store/actions/purchaseOrders';
import ReactPaginate from 'react-paginate';
import MaterialTable from 'material-table';
import { STATUS_PENDING } from '../../common/constants';
import { formatDate, accessPurchaseOrderManagement } from './../../common/utils/utility';
import { format } from 'date-fns';

const PurchaseOrderManagement = (props) => {
    const userInfo = useSelector((state) => state.auth.userInfo);
    const [loading, setLoading] = useState(true);
    const [purchaseOrderList, setPurchaseOrderList] = useState([]);
    const [list, setList] = useState([]);
    const [pageValue, setPageValue] = useState({
        offset: 0,
        perPage: 10,
        currentPage: 0,
        pageCount: 0
    });
    const [pageNumber, setPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(Math.ceil(purchaseOrderList?.length / pageValue.perPage));
    const [searchValue, setSearchValue] = useState('');

    const getPurchaseOrderData = () => {
        getPurchaseOrders(userInfo.supplierId).then(response => {
            setLoading(false);

            let dataSortedByCreatedDate = response.data?.result.sort((a, b) => a.custrecord_nbpoa_po_trandate.split('/').reverse().join().localeCompare(b.custrecord_nbpoa_po_trandate.split('/').reverse().join()));

            setPurchaseOrderList(dataSortedByCreatedDate);
            setPageCount(Math.ceil(response.data?.length / pageValue.perPage));
        }).catch((err) => {
            const errMsg = 'Something went wrong';
            props.showMessage(err?.response?.data?.error || errMsg);
        });
    };

    useEffect(() => {
        if (userInfo) {
            getPurchaseOrderData();
        }
    }, [userInfo]);

    useEffect(() => {
        setPageValue({
            ...pageValue,
            pageCount
        })
    }, [pageCount]);

    const handlePageClick = ({ selected }) => {
        setPageNumber(selected);
        const offset = selected * pageValue.perPage;
        setPageValue({
            ...pageValue,
            offset: offset,
            pageCount: pageCount,
            currentPage: selected
        });
    };

    const onSearch = ({ target: { value } }) => {
        setList(purchaseOrderList?.filter(item => value === '' || item.poNumber.toLowerCase().includes(value.toLowerCase()) || item.pickupNumber.toLowerCase().includes(value.toLowerCase()) || item.itemNumber.toLowerCase().includes(value.toLowerCase())) || []);
        handlePageClick({ selected: 0 });
        setSearchValue(value);
    }

    const renderRows = () => {
        const rowList = purchaseOrderList?.filter(item => searchValue === '' || item.displayName.toLowerCase().includes(searchValue.toLowerCase())) || [];
        return (
            <React.Fragment>
                <Col>
                    {
                        loading ? (
                            <div className="loadingContainer"></div>
                        ) : (
                            <MaterialTable
                                columns={[
                                        { title: 'Order Number', field: 'custrecord_nbpoa_po_tranid' },
                                        { title: 'Status', field: 'combinedStatus' },
                                        {
                                            title: 'Date Created', field: 'custrecord_nbpoa_po_trandate', render: rowData => {
                                                return rowData.custrecord_nbpoa_po_trandate
                                            },
                                        },
                                        {
                                            title: 'Pickup Date', field: 'custrecord_nbpoa_po_pickup_date', render: rowData => {
                                                return rowData.custrecord_nbpoa_po_pickup_date
                                            },
                                        },
                                        {
                                            title: 'Received Date', field: 'custrecord_nbpoa_po_receipt_date', render: rowData => {
                                                return rowData.custrecord_nbpoa_po_receipt_date
                                            }, 
                                        },
                                        { title: 'Total Weight', field: 'custrecord_nbpoa_cumulative_weight' },
                                ]}
                                data={rowList}
                                    onRowClick={(event, rowData) => { props.history.push('/home/PurchaseOrderDetail/' + rowData.custrecord_nbpoa_po, { data: rowData, isEdit: false }) }}
                                options={{
                                    filtering: false,
                                    actionsColumnIndex: -1,
                                    search: true,
                                    paging: true,
                                    toolbar: false,
                                    pageSize: 10,
                                    headerStyle: {
                                        backgroundColor: 'gray',
                                        color: '#FFF'
                                    },
                                }}
                            />
                        )
                    }
                </Col>
            </React.Fragment>
        );
    }


    return (
        <Container>
            {accessPurchaseOrderManagement(userInfo)}
            <Row className="page-header-container">
                <Col>
                    <h2 className="page-header">Order Management</h2>
                </Col>
            </Row>
            <Row className="page-content-container">
                <Col className="page-content-container-inner">
                    <Row>
                        {renderRows()}
                    </Row>
                    <Row>
                        <Col className="breadcrumbs-container">
                            <ReactPaginate
                                previousLabel={list.length ? "< Previous" : ''}
                                nextLabel={list.length ? "Next >" : ''}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={pageValue.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={(e) => { handlePageClick(e) }}
                                containerClassName={"breadcrumbs"}
                                subContainerClassName={"pages breadcrumbsinner"}
                                activeClassName={"active"}
                                forcePage={pageNumber}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
};

const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        showMessage: (msg, type) => dispatch(actions.showMessage(msg, type))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PurchaseOrderManagement);